import React from 'react';

const Show = function (props: {isShow?: boolean; children: React.ReactNode}) {
  const { isShow, ...rest } = props
  return (
    <div
      style={{
        display: isShow ? 'flex' : 'none',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        gridGap: '15px',
      }}
      {...rest}
    />
  );
};

export default Show;
